import {Forminator as Forms} from './classes/Forminator';
import {DoubleCheck} from '../modules/Doublecheck.js';

const forms = new Forms();
window.forms = forms;

DoubleCheck.bindDoublecheckAttributes({
    hasUnsavedForms: () =>
        forms.forms.some(f =>
            f.element?.hasAttribute?.('unload-listen') || f.isStepBased()
        ),
    clearGuards: () => {
        forms.forms.forEach(f => {
            window.removeEventListener('beforeunload', f.preventUnsavedChanges);
            window.removeEventListener('beforeunload', f.preventReload);
            f.element.removeAttribute('unload-listen');
            f.element.removeAttribute('submitting');
        });
    }
});